import { useState } from "react";
import { ColorSwatch, Group, Text } from "@mantine/core";
import { FilterSelect } from "./FilterSelect";
import { USER_STATUS } from "./UserStatusBadge";
import { useTranslation } from "react-i18next";
import classes from "./FilterSelect.module.css";

/**
 * AD-188: the "All Status" filter of User Management. Same control as the ads list's
 * status filter (AdStatusFilterSelect), with the three account statuses.
 */
export const UserStatusFilterSelect = ({ onChange, ...props }) => {
    const { t } = useTranslation();
    const [value, setValue] = useState('');
    const options = [
        { value: '', label: t('users.status.all') },
        ...Object.values(USER_STATUS).map((status) => ({
            value: String(status.code),
            label: t(`users.status.${status.key}`),
            dotColor: status.color,
        })),
    ];

    return (
        <FilterSelect
            placeholder={t('users.status.all')}
            w={160}
            data={options}
            value={value}
            renderOption={({ option }) => (
                <Group gap={8} wrap="nowrap">
                    {option.dotColor && <ColorSwatch color={option.dotColor} size={8} withShadow={false} />}
                    <Text fz={14} fw={400} className={classes.optionText} c="var(--option-fg)">{option.label}</Text>
                </Group>
            )}
            onChange={(val) => {
                setValue(val ?? '');
                onChange?.(val || null);
            }}
            {...props}
        />
    );
};
